module.exports = __webpack_public_path__ + "img/gif-dark-revolva.59c1aff0.gif";